module.exports = __webpack_public_path__ + "img/report-error.1da6d538.svg";